import { Button, Col, Layout, Row, Spin, Tabs, Typography } from 'antd'
import { ScreenTitle } from 'components/ScreenTitle'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { dateFormatter } from '../../app/services/helper'
import { ErrorOutlineRounded } from '@mui/icons-material'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

function ContentBox({
  children,
  title,
  hasContent = true,
  isLoading = false,
  isError = false,
  items,
  errorMessage = 'Xəta baş verdi',
  handleClick,
  activeKey,
}: {
  children: React.ReactNode
  title: string
  hasContent?: boolean
  isLoading?: boolean
  isError?: boolean
  errorMessage?: string
  handleClick?: () => void
  items?: any[]
  activeKey?: string
}) {
  const history = useHistory()
  const { t } = useTranslation()

  const onClickRight = () => {
    window.location.reload()
  }
  const onClickLeft = () => {
    history.push('/')
  }

  const handleTabChange = (key: string) => {
    const selectedItem = items?.find((item) => item.key === key)
    if (selectedItem) {
      history.push(selectedItem.path)
    }
  }

  return (
    <Row wrap style={{ flexDirection: 'column' }}>
      <Col span={24}>
        <ScreenTitle
          onClickRight={onClickRight}
          onClickLeft={onClickLeft}
          leftValue={title}
          rightValue={dateFormatter(new Date())}
        />
      </Col>
      <Col span={24}>
        <Tabs
          activeKey={activeKey}
          onChange={handleTabChange}
          className={styles.navbar}
          items={items}
        />
        <Layout.Content
          className={styles.responsive}
          {...(hasContent
            ? {
                style: {
                  backgroundColor: '#fff',
                  padding: 20,
                  borderRadius: items ? 0 : 10,
                },
              }
            : {})}
        >
          {isLoading ? (
            <Row justify="center" align="middle" style={{ minHeight: 500 }}>
              <Spin size="large" />
            </Row>
          ) : isError ? (
            <Row
              justify="center"
              align="middle"
              style={{ gap: 20, minHeight: 500, flexDirection: 'column' }}
            >
              <ErrorOutlineRounded style={{ color: '#FF4E57', fontSize: 64 }} />
              <Typography.Text style={{ fontSize: 18 }}>
                {errorMessage}
              </Typography.Text>
              <Button type="link" onClick={onClickLeft}>
                {t('common.returnHome')}
              </Button>
            </Row>
          ) : (
            <div>{children}</div>
          )}
        </Layout.Content>
      </Col>
    </Row>
  )
}

export default ContentBox
